import { VerifyEmailView } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function VerifyEmailPage() {
  setPageTitle('Verify Email');
  return <VerifyEmailView />;
}
